import LayoutSectionMembership from './layout_section_membership';
import { filter, map, min, reject, uniq } from 'lodash';
import EventPublisher from '../utilities/event_publisher';

export default class LayoutSection {
  constructor(id, identifier, sortOrder, memberships) {
    this.id = id;
    this.identifier = identifier;
    this.sortOrder = sortOrder;
    this.members = memberships;
    this.positionIds = uniq(map(memberships, 'positionId'))
    this.isHighlighted = false;
  }

  static fromAttributes({ id, identifier, sort_order, layout_section_memberships }) {
    return new LayoutSection(
      id,
      identifier,
      sort_order,
      layout_section_memberships.map(member => LayoutSectionMembership.fromAttributes(member))
    );
  }

  serialize() {
    return {
      identifier: this.identifier,
      sort_order: this.sortOrder,
    }
  }

  addMembership(positionId) {
    this.members = [...this.members, { positionId, sectionId: this.id }];
  }

  deleteMembership(positionId) {
    this.members = reject(this.members, { positionId: positionId });
  }

  hydratePositions(positions) {
    this.positions = filter(positions, pos => pos.sectionIds.includes(this.id))
  }

  get minX() {
    return min(map(this.positions, 'x'))
  }
  get minY() {
    return min(map(this.positions, 'y'))
  }

  highlightPositions() {
    EventPublisher.publish('section-highlighted', { positionIds: this.positionIds });
  }

  unhighlightPositions() {
    EventPublisher.publish('section-unhighlighted', { positionIds: this.positionIds });
  }

  get positionIds() {
    return this.members.map(member => member.positionId);
  }

  set positionIds(ids) {
    this.positionsIds = ids
  }
}
